import { sortBy } from "lodash-es";
import {BookingMetaByEquipment} from "../../../constants";

const metaFieldsKeys = Object.keys(BookingMetaByEquipment.fields)
const BOOKING_CORE = metaFieldsKeys.filter( key => BookingMetaByEquipment.fields[key].lockVisible)

export const onAgGridColumnApply = ({ gridRef, savedShowcolumns }) => {
  if (!gridRef?.current?.columnApi || !savedShowcolumns) return;


  let columnState = gridRef.current.columnApi.getColumnState();
  const showColumns = sortBy(savedShowcolumns, ["order"], ["asc"]);

  // What stays visible, by identity: the locked booking columns, whatever the user saved, and the
  // actions column. Everything else is hidden — including any column the schema knows about that
  // the saved layout predates.
  const visibleIds = new Set([
    ...BOOKING_CORE,
    ...showColumns.map(c => c.key),
    'actions',
  ]);

  // Order only. Each saved column is moved into its saved position, after the locked ones.
  showColumns.forEach((column, orderIndex) => {
    const index = columnState.findIndex((c) => c.colId === column.key);
    if (index === -1) return;
    const [splicedObj] = columnState.splice(index, 1);
    splicedObj.hide = splicedObj.colId === "equipment_model";
    columnState.splice(orderIndex + BOOKING_CORE.length, 0, splicedObj);
  });

  // Visibility, by identity rather than by position. A positional rule was tried here and does not
  // hold: it hid everything at or past `BOOKING_CORE.length + showColumns.length`, but the loop
  // above skips saved columns the grid no longer has while `orderIndex` still advances, so that
  // threshold over-counts and leaves a column that should be hidden inside the visible region.
  // Stored layouts routinely reference columns that no longer exist, so this must not depend on
  // index arithmetic.
  columnState = columnState.map(col => ({
    ...col,
    hide: !visibleIds.has(col.colId) || col.hide,
  }));

  const coreStates = [];
  BOOKING_CORE.forEach((id) => {
    const idx = columnState.findIndex((c) => c.colId === id);
    if (idx > -1) coreStates.push(...columnState.splice(idx, 1));
  });
  columnState = [...coreStates, ...columnState];

  gridRef.current.columnApi.applyColumnState({
    state: columnState,
    applyOrder: true,
  });
};
